const call = (...args) => {
    if (window.Intercom) {
        window.Intercom(...args);
    }
    else {
        throw new Error('Intercom has not been installed yet.');
    }
};
export const shutdown = () => call('shutdown');
export const boot = (opt) => call('boot', opt);
export const update = (options) => call('update', options);
export const show = () => call('show');
export const hide = () => call('hide');
export const showMessages = () => call('showMessages');
export const showNewMessage = (content) => call('showNewMessage', content);
export const trackEvent = (name, ...metadata) => () => call('trackEvent', name, ...metadata);
export const getVisitorId = () => call('getVisitorId');
